import axios from 'axios';

const findAlmanacSellerSubscription = async (
  dashboardId: string,
  listingId?: string,
) => {
  const config = {
    url: `/external/dash/${dashboardId}/almanac/subscriptions`,
    method: 'get' as const,
    params: {
      listingId,
    },
  };

  const { data } = await axios.request<{ id: string }>(config);
  return data;
};

export default findAlmanacSellerSubscription;
